import { Injectable, Inject, forwardRef } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Response } from '@angular/http';
import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../../reducers';

import { TicketDesignApi } from "../../../services";
import { TicketDesignActions } from './ticket-design.actions'
import { MessageActions, EventActions } from '../../../actions';
import { ErrorHandlerService } from '../../../services/index';
import { TicketDesignUsage, TicketDesign, TicketDesignTypes } from "../../../models";
import { UnsafeAction } from "../../../actions/UnsafeAction";

/* tslint:disable */
@Injectable()
export class TicketDesignEffects {

	constructor(
		private updates$: Actions,
		private store: Store<AppState>,
		private ticketDesignActions: TicketDesignActions,
		private messageActions: MessageActions,
		private ticketDesignApi: TicketDesignApi,
		private errorHandler: ErrorHandlerService
	) { }

	@Effect() eventLoaded$ = this.updates$
		.ofType(EventActions.EVENT_LOADED)
		.filter((action:UnsafeAction) => action.payload)
		.map((action:UnsafeAction)  => this.ticketDesignActions.loadTicketDesignUsagesByEventUuid(action.payload.uuid))

	@Effect() loadTicketDesignUsages$ = this.updates$
		.ofType(TicketDesignActions.LOAD_TICKET_DESIGN_USAGES_BY_EVENT_UUID)
		.flatMap((action:UnsafeAction)  => this.ticketDesignApi.findTicketDesignUsagesByEventUuid(action.payload))
		.map(ticketDesignUsages => this.ticketDesignActions.ticketDesignUsagesByEventUuidLoaded(ticketDesignUsages))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() ticketDesignUsagesLoaded$ = this.updates$
		.ofType(TicketDesignActions.TICKET_DESIGN_USAGES_BY_EVENT_UUID_LOADED)
		.map((action:UnsafeAction) => {
			if (action.payload.length === 0) {
				this.store.dispatch(this.ticketDesignActions.hideSpinner())
			}
			return action
		})
		.flatMap((action:UnsafeAction) => action.payload)
		.flatMap((ticketDesignUsage: TicketDesignUsage) => this.ticketDesignApi.getPreview(ticketDesignUsage._links.preview_base64_png.href)
			.map(base64Preview => this.ticketDesignActions.ticketDesignPreviewImageLoaded(base64Preview, ticketDesignUsage.ticketDesignType))
		)
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))

	@Effect() uploadTicketDesign$ = this.updates$
		.ofType(TicketDesignActions.UPLOAD_TICKET_DESIGN)
		.flatMap((action:UnsafeAction) => this.ticketDesignApi.uploadTicketDesign(action.payload.file)
			.do(event => this.store.dispatch(this.ticketDesignActions.uploadStatus(event, action.payload.ticketDesignType)))
		).catch(error =>
			Observable.concat(
				this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
				Observable.of(this.ticketDesignActions.hideSpinner())
			)
		)

	@Effect() uploadStatus$ = this.updates$
		.ofType(TicketDesignActions.UPLOAD_STATUS)
		.map((action: UnsafeAction) => {
			if (action.payload.event.currentTarget && action.payload.event.currentTarget["status"] && action.payload.event.currentTarget["status"] === 200) {
				let ticketDesign =  <TicketDesign>JSON.parse(action.payload.event.currentTarget["responseText"])
				return this.ticketDesignActions.ticketDesignUploaded(ticketDesign, action.payload.ticketDesignType)
			} else {
				return this.ticketDesignActions.showSpinner()
			}
		})

	@Effect() ticketDesignUploaded$ = this.updates$
		.ofType(TicketDesignActions.TICKET_DESIGN_UPLOADED)
		.flatMap((action:UnsafeAction) => this.ticketDesignApi.getPreview(action.payload.ticketDesign._links.preview_base64_png.href)
			.map(base64Preview => this.ticketDesignActions.ticketDesignPreviewImageLoaded(base64Preview, action.payload.ticketDesignType))
		)
		.catch(error =>
			Observable.concat(
				this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
				Observable.of(this.ticketDesignActions.hideSpinner())
			)
		)

	@Effect() ticketDesignPreviewImageLoaded$ = this.updates$
		.ofType(TicketDesignActions.TICKET_PREVIEW_IMAGE_LOADED)
		.map(action => this.ticketDesignActions.hideSpinner())
		.catch(error =>
		Observable.concat(
				this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
				Observable.of(this.ticketDesignActions.hideSpinner())
			)
		)

	@Effect() saveTicketDesignUsage$ = this.updates$
		.ofType(TicketDesignActions.SAVE_TICKET_DESIGN_USAGE)
		.flatMap((action:UnsafeAction) => {
			if (action.payload.ticketDesignType === TicketDesignTypes.TICKET_PRINT) {
				return this.ticketDesignApi.saveTicketDesignUsageTicketPrint(action.payload.designUuid, action.payload.eventUuid)
			} else if (action.payload.ticketDesignType === TicketDesignTypes.PRINT_AT_HOME) {
				return this.ticketDesignApi.saveTicketDesignUsagePrintAtHome(action.payload.designUuid, action.payload.eventUuid)
			}
		}).flatMap((ticketDesignUsage: TicketDesignUsage) =>
		Observable.concat(
				[
					this.ticketDesignActions.ticketDesignUsageSaved(ticketDesignUsage),
					this.messageActions.displayMessage("Das Design wurde gespeichert", "success")
				])
		)
		.catch(error =>
			Observable.concat(
				this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
				Observable.of(this.ticketDesignActions.hideSpinner())
			)
		)

	@Effect() deleteTicketDesignTicketPrint$ = this.updates$
		.ofType(TicketDesignActions.DELETE_TICKET_DESIGN_TICKET_PRINT)
		.withLatestFrom(this.store)
		.switchMap(([action, store]) => this.ticketDesignApi.deleteTicketDesign(
			store.eventServerState.ticketDesigns.ticketPrintDesignUuid)
			.flatMap((action) =>
				Observable.concat([
					this.ticketDesignActions.showSpinner(),
					this.ticketDesignActions.ticketDesignTicketPrintDeleted(),
					this.ticketDesignActions.loadTicketDesignUsagesByEventUuid(store.eventServerState.event.currentEvent.uuid),
				])
			)
			.catch(error =>
				Observable.concat(
					this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
					Observable.of(this.ticketDesignActions.hideSpinner())
				)
			)
		)

	@Effect() deleteTicketDesignPrintAtHome$ = this.updates$
		.ofType(TicketDesignActions.DELETE_TICKET_DESIGN_PRINT_AT_HOME)
		.withLatestFrom(this.store)
		.switchMap(([action, store]) => this.ticketDesignApi.deleteTicketDesign(
			store.eventServerState.ticketDesigns.printAtHomeTicketDesignUuid)
			.flatMap((action) =>
				Observable.concat(
					[
						this.ticketDesignActions.showSpinner(),
						this.ticketDesignActions.ticketDesignPrintAtHomeDeleted(),
						this.ticketDesignActions.loadTicketDesignUsagesByEventUuid(store.eventServerState.event.currentEvent.uuid),
					]
				)
			)
			.catch(error =>
				Observable.concat(
					this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
					Observable.of(this.ticketDesignActions.hideSpinner())
				)
			)
		)

	@Effect() deleteTicketDesignUsageTicketPrint$ = this.updates$
		.ofType(TicketDesignActions.DELETE_TICKET_DESIGN_USAGE_TICKET_PRINT)
		.withLatestFrom(this.store)
		.switchMap(([action, store]) => this.ticketDesignApi.deleteTicketDesignUsage(
			store.eventServerState.ticketDesigns.ticketPrintTicketDesignUsage.uuid)
			.flatMap((action) =>
				Observable.concat(
					[
						this.ticketDesignActions.ticketDesignUsageTicketPrintDeleted(),
						this.ticketDesignActions.loadTicketDesignUsagesByEventUuid(store.eventServerState.event.currentEvent.uuid),
						this.messageActions.displayMessage("Das Ticket-Design wurde gelöscht", "success")
					]
				)
			)
			.catch(error =>
				Observable.concat(
					this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
					Observable.of(this.ticketDesignActions.hideSpinner())
				)
			)
		)

	@Effect() deleteTicketDesignUsagePrintAtHome$ = this.updates$
		.ofType(TicketDesignActions.DELETE_TICKET_DESIGN_USAGE_PRINT_AT_HOME)
		.withLatestFrom(this.store)
		.switchMap(([action, store]) => this.ticketDesignApi.deleteTicketDesignUsage(
			store.eventServerState.ticketDesigns.printAtHomeTicketDesignUsage.uuid)
			.flatMap((action) =>
				Observable.concat(
					[
						this.ticketDesignActions.ticketDesignUsagePrintAtHomeDeleted(),
						this.ticketDesignActions.loadTicketDesignUsagesByEventUuid(store.eventServerState.event.currentEvent.uuid),
						this.messageActions.displayMessage("Das Print@Home-Design wurde gelöscht", "success")
					]
				)
			)
			.catch(error =>
				Observable.concat(
					this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."),
					Observable.of(this.ticketDesignActions.hideSpinner())
				)
			)
		)

	private handleError(error:Response, defaultMessage:string):Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-designs/ticket-design.effects.ts